import { render } from "./white-progress-spinner.vue?vue&type=template&id=ac6f6a76&scoped=true"
import script from "./white-progress-spinner.vue?vue&type=script&lang=js"
export * from "./white-progress-spinner.vue?vue&type=script&lang=js"

import "./white-progress-spinner.vue?vue&type=style&index=0&id=ac6f6a76&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ac6f6a76"

export default script